<template>
  <div id="header_bn">
    <div class="header_bn">
      <a href="http://www.baonengjet.com" title="宝能公务航空">
        <img
          class="header_logo"
          src="http://www.baonengjet.com/wp-content/uploads/2020/03/Baoneng-Logo-New-Small-2.jpg"
          alt="宝能公务航空"
        />
      </a>
      <div class="h_right">
        <ul class="nav">
          <li @mouseenter="handleHover">
            <a href="http://www.baonengjet.com" >首页</a>
          </li>
          <li>
            <a href="http://www.baonengjet.com/topics/category/flight_charter/">我要包机</a>
          </li>
          <li>
            <a href="http://www.baonengjet.com/topics/category/vip/">会员尊享</a>
          </li>
          <li>
            <a href="http://www.baonengjet.com/topics/category/jet_agent/">成为机主</a>
          </li>
          <li @mouseenter="handleHover">
            <a href="http://www.baonengjet.com/topics/category/trusteeship/">飞机托管</a>
          </li>
          <li>
            <a href="http://www.baonengjet.com/topics/category/aboutus/">关于我们</a>
          </li>
          <li>
            <a href="http://www.baonengjet.com/contact2/">联系我们</a>
          </li>
        </ul>
      </div>
    </div>
    <div id="subNav_box">
      <div class="cnt">
        <div class="g-wrap">
          <div class="item sN1" style="display:none;"></div>
          <div class="item sN2">
            <a
              href="http://www.baonengjet.com/topics/%e5%85%ac%e5%8a%a1%e6%9c%ba%e5%ae%a2%e8%88%b1%e6%9c%8d%e5%8a%a1/"
            >奢华的客舱服务</a>
            <a
              href="http://www.baonengjet.com/topics/%e5%85%ac%e5%8a%a1%e6%9c%ba%e6%9c%ba%e5%9e%8b%e4%bb%8b%e7%bb%8d/"
            >机型介绍</a>
          </div>
          <div class="item sN3">
            <a
              href="http://www.baonengjet.com/topics/%e5%8c%85%e6%9c%ba%e4%bc%9a%e5%91%98%e5%b0%8a%e4%ba%ab/"
            >会员尊享</a>
          </div>
          <div class="item sN4">
            <a
              href="http://www.baonengjet.com/topics/%e5%85%ac%e5%8a%a1%e6%9c%ba%e8%b4%ad%e6%9c%ba%e4%bb%a3%e7%90%86%e6%9c%8d%e5%8a%a1/"
            >采购代理</a>
          </div>
          <div class="item sN5">
            <a
              href="http://www.baonengjet.com/topics/%e5%85%ac%e5%8a%a1%e6%9c%ba%e6%89%98%e7%ae%a1%e4%bc%98%e5%8a%bf/"
            >托管优势</a>
          </div>
          <div class="item sN6">
            <a
              href="http://www.baonengjet.com/topics/%e5%ae%9d%e8%83%bd%e5%85%ac%e5%8a%a1%e8%88%aa%e7%a9%ba/"
            >宝能公务航空</a>
            <a href="http://www.baoneng.com">宝能集团</a>
          </div>
          <div class="item sN7" style="display:none;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import 'bootstrap/dist/css/bootstrap.min.css'
import $ from 'jquery'

export default {
  name: 'BnjHeader',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
      const _this = this
      $(".nav li").hover(function () {
        $(".nav li a").css("color", "#666");
        $(this).find("a").css("color", "#076ebe");
        var i = $(this).index();
        if (i != 0) {
            $("#subNav_box .item").removeClass('curr');
            $("#subNav_box .item").eq(i).addClass('curr');
            $("#subNav_box").addClass("on");
        } else {
            $("#subNav_box .item").removeClass('curr');
            $("#subNav_box").removeClass("on");
        }
    });
    $("#header_bn").hover(function () {}, function () {
        $(".nav li a").css("color", "#666");
        $(".nav li.on a").css("color", "#076ebe");
        $("#subNav_box .item").removeClass('curr');
        $("#subNav_box").removeClass("on");
    });

    $("#subNav_box .item").each(function () {
        var i = $(this).index();
        var le = $(".nav li").eq(i).position().left;
        if (i == 7) {
            $(this).css("left", le - 218);
        } else if (i == 6) {
            $(this).css("left", le - 188);
        } else {
            $(this).css("left", le);
        }
    });

  }
}

</script>

<style scoped>
@import "../assets/styles/style.css";
</style>



// WEBPACK FOOTER //
// src/components/bnj-header.vue